import { useId, useState } from 'react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { track } from '@/lib/analytics';

const FaqItem = ({ item, index, open, onToggle }) => {
  const id = useId();
  return (
    <div className="border-b border-candy-line" data-testid={`faq-item-${index}`}>
      <h3>
        <button
          type="button"
          id={`${id}-q`}
          aria-expanded={open}
          aria-controls={`${id}-a`}
          onClick={onToggle}
          className="flex min-h-[60px] w-full items-center justify-between gap-4 py-2 text-left text-[17px] font-medium text-candy-ink"
        >
          {item.question}
          <span className="grid h-8 w-8 flex-none place-items-center rounded-full bg-candy-bg">
            <Plus
              className={`h-3.5 w-3.5 transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`}
              strokeWidth={2.6}
              aria-hidden="true"
            />
          </span>
        </button>
      </h3>
      <div
        id={`${id}-a`}
        role="region"
        aria-labelledby={`${id}-q`}
        className={`grid transition-[grid-template-rows,visibility] duration-200 ease-out ${open ? 'visible grid-rows-[1fr]' : 'invisible grid-rows-[0fr]'}`}
      >
        <div className="overflow-hidden">
          <p className="pb-5 pr-12 text-candy-ink-muted">{item.answer}</p>
        </div>
      </div>
    </div>
  );
};

export const PrivacyFaq = ({ faqs }) => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex((cur) => (cur === i ? null : i));
    if (openIndex !== i) track('faq_open', { question_index: i });
  };

  return (
    <section className="mx-auto flex max-w-content flex-col gap-6 px-4 py-10 md:flex-row md:flex-wrap md:px-6 md:py-[60px]" data-testid="faq-section">
      <div className="min-w-0 rounded-block bg-candy-cyan p-7 md:flex-[1_1_380px] md:p-10" data-testid="discreet-delivery-section">
        <h2 className="font-heading text-[32px] font-extrabold leading-none tracking-[-0.035em] md:text-[40px]">{t('privacy.title')}</h2>
        <p className="mt-[18px] text-[17px]">{t('privacy.text')}</p>
        <ul className="mt-[26px] flex flex-wrap gap-2.5">
          <li className="rounded-full bg-candy-surface px-4 py-2.5 text-sm font-bold">{t('privacy.packaging')}</li>
          <li className="rounded-full bg-candy-surface px-4 py-2.5 text-sm font-bold">{t('privacy.billing')}</li>
        </ul>
      </div>

      <div id="faq" className="min-w-0 rounded-block bg-candy-surface p-7 md:flex-[1_1_520px] md:p-10">
        <h2 className="font-heading text-[32px] font-extrabold leading-none tracking-[-0.035em] md:text-[40px]">{t('faq.title')}</h2>
        <div className="mt-4">
          {faqs.map((item, i) => (
            <FaqItem key={item.question} item={item} index={i} open={openIndex === i} onToggle={() => toggle(i)} />
          ))}
        </div>
      </div>
    </section>
  );
};
